export enum ContractInfoTypeOptions {
  FUEL = 'bd2ff502-27f3-476b-8329-781d31d2b312',
  INFLATION = '314bcac2-90fd-4f25-ae27-f8e01590464a',
  ELECTRIC = 'cd5a295c-5bb3-4730-8a33-468dda734ccb',
  CURRENCY = 'a89eb173-3914-48ff-a96e-634ee69e710e',
  MINIMUM_WAGE = 'd0781537-77b7-428d-8d73-646e7ccc9bc2'
}
